export enum ProductTypes {
  AC = 'AC',
  MU = 'MU',
  PR = 'PR',
  PT = 'PT',
  RE = 'RE',
}
